import { BaseError } from './base.js';
export class DuplicateError extends BaseError {
    httpStatus = 409;
}
